// extracted by css-extract-rspack-plugin
export default {"input":"BannerModerationInfo-module__input--FVNjw"};